import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskLanguageRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-language',
	path: '/jira/servicedesk/projects/:projectKey/settings/language',
	exact: true,
};
